import { API_ENDPOINTS } from "../api";
import type { GetDataModelCatalogQuery } from "./dataModelCatalog.types";
import type {
  DataModelSortBy,
  GetDataModelsQuery,
} from "./dataModels.types";

const LIVE_LIST_SORT_BY = new Set<DataModelSortBy>([
  "name",
  "createdAt",
  "updatedAt",
]);

export const buildListUrl = (
  workspaceId: string,
  query?: GetDataModelsQuery,
): string => {
  const params = new URLSearchParams();
  if (query?.limit != null) params.set("limit", String(query.limit));
  if (query?.offset != null) params.set("offset", String(query.offset));
  if (query?.search) params.set("search", query.search);
  if (query?.status) params.set("status", query.status);
  if (query?.sortBy && LIVE_LIST_SORT_BY.has(query.sortBy)) {
    params.set("sort_by", query.sortBy);
  }
  if (query?.sortOrder) params.set("sort_order", query.sortOrder);
  const qs = params.toString();
  const base = API_ENDPOINTS.dataModels.list(workspaceId);
  return qs ? `${base}?${qs}` : base;
};

export const buildCatalogUrl = (
  workspaceId: string,
  query?: GetDataModelCatalogQuery,
): string => {
  const params = new URLSearchParams();
  if (query?.search) params.set("search", query.search);
  if (query?.entityType) params.set("entity_type", query.entityType);
  if (query?.pageSize != null) params.set("page_size", String(query.pageSize));
  if (query?.cursor) params.set("cursor", query.cursor);
  if (query?.sourceSystem) params.set("source_system", query.sourceSystem);
  const qs = params.toString();
  const base = API_ENDPOINTS.dataModels.catalog(workspaceId);
  return qs ? `${base}?${qs}` : base;
};
